export var MISSING_EXTERNAL_CUSTOMER_ID_ERROR = 'External customer ID is required. Please review the widget configuration and try again.';
export var normalizeExternalCustomerID = function (value) {
    if (value === null || value === undefined) {
        return null;
    }
    var normalizedValue = String(value).trim();
    return normalizedValue || null;
};
